module.exports = __webpack_public_path__ + "static/img/nguyenthinu.2fa1ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nguyenthinu.png
// module id = uQxo
// module chunks = 1